import React, { useCallback, useState } from "react";
import { trashOutline } from "ionicons/icons";
import { IonIcon } from "@ionic/react";
import { tryCatch } from "../utils";
import api from "../api";
import NewModal from "./NewModal";

interface Props {
  id: string;
  name: string;
  onDeleted: () => void;
}
const fontSize = 26;

const DeleteDevice: React.FC<Props> = ({ id, name, onDeleted }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onDeleteDeviceClick = useCallback(() => {
    setIsModalOpen(true);
  }, []);
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const deleteDevice = useCallback(async () => {
    setIsModalOpen(false);

    const setDeviceSettingResult = await tryCatch(
      api.device.deleteDevice({ id })
    );

    if (setDeviceSettingResult.error) {
      console.log("Failed to delete device!");
    } else {
      onDeleted();
    }
  }, [id, onDeleted]);

  return (
    <>
      <button
        type="button"
        className={`transition
      focus:outline-none focus:ring-2 focus:ring-offset-2 text-orange focus:ring-orange-500  unstyled status text-gr
    disabled:text-gray-400 disabled:cursor-not-allowed
      hover:scale-125
      `}
        onClick={onDeleteDeviceClick}
        title="delete-device-button"
        data-testid="delete-device-button"
      >
        <IonIcon icon={trashOutline} style={{ fontSize }} />
      </button>
      <NewModal
        type="warning"
        open={isModalOpen}
        onClose={closeModal}
        onOk={deleteDevice}
        title="Delete Device"
        description={`Are you sure you would like to delete the device ${name}?`}
        okText="Yes"
        cancelText="Cancel"
        okTestId="dd-ok"
      />
    </>
  );
};

export default DeleteDevice;
